import React, { useContext, useEffect } from 'react';
import Project from './Project';

import projectContext from '../../context/projects/projectContext';

import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AlertContext from '../../context/alerts/alertContext';

const ProjectList = () => {

    const projectsContext = useContext(projectContext);
    const { projects, message, getProjects } = projectsContext;

    // Importing the information of the state alert context
    const alertContext = useContext(AlertContext);
    const { alert, showAlert } = alertContext;
    
    useEffect(() => {
        // If an error occurs
        if(message){
            showAlert( message.msg, message.category );
        }
        // Get the projects
        getProjects();
        //eslint-disable-next-line
    }, [message]);

    //if( projects.length === 0 ) return null;
    if( projects.length === 0 ) return <p>There are no projects, start creating at least one</p>;

    return ( 
        <ul className="listado-proyectos">
            { alert ? <div className={`alerta ${ alert.category }`}>{ alert.msg }</div> : null }
            <TransitionGroup>
            { 
                projects.map(project => (
                    <CSSTransition
                        key={ project._id }
                        timeout={ 300 }
                        classNames="project"
                    >
                        <Project 
                            project={ project }
                        />
                    </CSSTransition>
            )) 
            }
            </TransitionGroup>
        </ul>
     );
}
 
export default ProjectList;